import { DeclaredBusinessType } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { PhoneFormDoubleField } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/PhoneFormDoubleField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { AcquisitionChannelOptions } from '@/constants/AcquisitionChannelOptions';
import { AmountOfEmployeesOptions } from '@/constants/AmountOfEmployeesOptions';
import { DeclaredBusinessTypeOptions } from '@/constants/DeclaredBusinessTypeOptions';
import { MerchantCategoryOptions } from '@/constants/MerchantCategoryOptions';
import { TurnoverOptions } from '@/constants/TurnoverOptions';

interface CreateMerchantFormProps extends FormGridOptions {}

export const CreateMerchantForm = ({ fieldVariant, fullWidth }: CreateMerchantFormProps) => {
  const { getTextIdTranslation } = useTranslation();
  const { watch } = useFormContext();
  const declaredBusinessType = watch('merchantDeclaredBusinessType');

  const corporateIdLabel =
    declaredBusinessType === DeclaredBusinessType.LTD ? 'CIF' : 'DOCUMENT_ID_NUMBER';

  return (
    <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
      <TextFormField label={'CONTACT_PERSON_FIRSTNAME'} name={'merchantFirstName'} />
      <TextFormField label={'CONTACT_PERSON_LASTNAME'} name={'merchantLastName'} />
      <PhoneFormDoubleField fieldVariant={fieldVariant} />
      <TextFormField label={'EMAIL'} name={'merchantEmail'} />
      <TextFormField label={'BUSINESS_NAME_FISCAL'} name={'merchantBusinessName'} />
      <SelectFormField
        name={'merchantDeclaredBusinessType'}
        label={'DECLARED_BUSINESS_TYPE'}
        selectOptions={DeclaredBusinessTypeOptions}
      />
      <TextFormField label={corporateIdLabel} name={'merchantCorporateIdNumber'} />
      <TextFormField label={'POSTAL_CODE'} name={'merchantPostalCode'} />
      <SelectFormField
        name={'merchantAmountOfEmployees'}
        label={'AMOUNT_OF_EMPLOYEES'}
        selectOptions={AmountOfEmployeesOptions}
      />
      <SelectFormField
        name={'merchantCategory'}
        label={'MERCHANT_CATEGORY'}
        selectOptions={MerchantCategoryOptions(getTextIdTranslation)}
      />
      <SelectFormField name={'merchantTurnover'} label={'TURNOVER'} selectOptions={TurnoverOptions} />
      <SelectFormField name={'channel'} label={'ACQUISITION_CHANNEL'} selectOptions={AcquisitionChannelOptions} />
    </FormGridContainer>
  );
};
